<template>
    <div class="product-page">
        <div @click="goBack()" class="back-button body-base color-link font-bold hov-underline flex-shrink-0 w-100 cursor-pointer">&lt; BACK</div>
        <div class="curated-boxes-page">
            <div v-if="!isMobile" class="curated-boxes-images-container">
                <div class="images-container">
                    <img :src="currentImage" class="main-image">
                    <div class="extra-images-container">
                        <Flicking ref="flicking" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true,renderOnlyVisible: true,horizontal: false }">
                            <template v-for="image in curatedBoxImages" >
                            <img 
                                class="extra-image"
                                :class="image.src == currentImage ? 'selected' : ''"
                                :src="image.src"
                                loading="lazy"
                                @click="selectImage(image.src)"
                            >
                            </template>
                        </Flicking>
                    </div>
                </div>
                <div v-if="!isMobile" class="product-legend">
                    <p class="title">Ship exactly how you need. In checkout, you'll be able to:</p>
                    <p class="subcopy">
                        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/ship_7cab1626-214e-4ea1-9ee3-da0e85c3e33c.svg?v=1724856350"/>
                        <span>
                            Bulk ship to one location, ship to many individual addresses, or a mix of both!
                        </span>
                    </p>
                    <p class="subcopy postcard">
                        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/address_fd703cb6-c0b9-46dc-9547-e254a460054a.svg?v=1724856349"/>
                        <span>
                            Ship with just an email address. (no physical address needed)
                        </span>
                    </p>
                    <p class="subcopy box-wing">
                        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/shipping_speed.svg?v=1724856349"/>
                        <span>Select your shipping speed: rush or standard, international or domestic.</span>
                    </p>
                </div>
            </div>
            <VueSlickCarousel v-else-if="curatedBoxImages.length > 0" :infinite="true" :dots="true" :arrows="false" :slidesToShow="1" :slidesToScroll="1">
                <div class="curated-boxes-images-container" v-for="image in curatedBoxImages" :key="image.src">
                <img class="main-image" :src="image.src"/>
                </div>
            </VueSlickCarousel>
            <div class="curated-boxes-main-container">
                <p class="main-title">{{curatedBoxTitle}}</p>
                <div class="qty-wrapper">
                    <div class="box-qty-container">
                        <div class="input-container">
                            <div class="box-qty-input-container" :class="canAddMore ? '' : 'no-more'">
                                <button :disabled="selectedBoxQty < minQty" @click="incrementBoxQty(false)">-</button> 
                                <input :disabled="true" @blur="changeBoxQty(null)" v-model="selectedBoxQty" type="number" min="1"> 
                                <button v-tooltip="{content: 'Not enough inventory', container:false}" @click="incrementBoxQty(true)">+</button> 
                            </div>
                            <p class="min-alert" v-if="minQty > 1">Minimum: {{ minQty }}</p>
                        </div>
                        <div class="price-container">
                            <p class="price">{{currentPrice}}</p>
                        </div>
                    </div>
                    <div v-if="selectedBoxQty > 1 && !paidCard" class="blank-card-container desktop-flex">
                        <input v-model="hasMultipleCards" @change="changeMultipleCards" id="multipleCards" type="checkbox">
                        <label for="multipleCards">I want multiple cards!</label>
                    </div>
                </div>
                <p class="desc-title">Description</p>
                <p class="product-desc" :class="descExpanded ? 'expanded' : ''" v-html="description"></p>
                <p @click="() => {descExpanded = !descExpanded}" class="purple-expand mobile">Show {{ descExpanded ? 'less' : 'more' }}</p>
                <p class="branding-legend" v-if="isDropship">Note: <i>This item ships directly from a trusted partner and can’t be scheduled ahead. Shipping timelines may vary, and if you're gifting this product along with other Happy Box goodies, it’ll arrive separately.</i></p>
                <p class="branding-legend"><i>Need a higher quantity or want to add branding? Email <a href="mailto:corporate@happyboxstore.com">corporate@happyboxstore.com</a>. Typical response time: 1 business day.</i></p>
                <div class="qty-wrapper">
                    <div v-if="selectedBoxQty > 1 && !paidCard" class="blank-card-container">
                    <input v-model="hasMultipleCards" @change="changeMultipleCards" id="multipleCards" type="checkbox">
                    <label for="multipleCards">I want multiple cards!</label>
                </div>
                </div>
                <div id="write-container" class="write-container" v-if="!noCard && !paidCard && !hasMultipleCards">
                    <div class="pick-card-container">
                        <div class="pick-card-header">
                            <p class="title">Pick Your Card</p>
                            <div class="arrows-container">
                                <img @click="$refs.featured.prev();" class="l-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="left arrow"/>
                                <img @click="$refs.featured.next();" class="r-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="right arrow"/>
                            </div>
                            <div class="blank-card-container">
                                <input v-model="isNoCard" id="noCard" type="checkbox">
                                <label for="noCard">Skip your Card</label>
                            </div>
                        </div>
                        <p v-if="showCardAlert" class="red-alert">Please select a card</p>
                        <div v-if="!isNoCard && cardProducts.length > 0" class="cards-container">
                            <Flicking ref="featured" class="flicking-goc-collection" :plugins="plugins1" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: 5 }">
                                <div class="card-container" @click="selectCard(card)" :class="selectedCard.id == card.id ? 'selected' : ''" v-for="card in sortedCards" :key="card.id">
                                    <img v-if="selectedCard.id == card.id " class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                                    <img class="main-image" :src="card | getProductImage"/>
                                </div>
                            </Flicking>
                        </div>
                        <ul v-else-if="!isNoCard && cardProducts.length == 0" class="cards-container no-scrollbar">
                            <li class="card-container" v-for="n in 12" :key="n">
                                <CardSkeleton/>
                            </li>
                        </ul>
                    </div>
                    <div v-if="!isNoCard" class="write-header">
                        <p class="title">Write Your Note</p>
                        <div class="blank-card-container">
                            <input v-model="isEmptyMessage" id="blankCard" type="checkbox">
                            <label for="blankCard">Leave the card blank</label>
                        </div>
                    </div>
                    <div v-if="!isNoCard && !isEmptyMessage" class="form-container">
                        <p class="purple-span">Type in your message below. A real human will hand write your message and include it in your gift.</p>
                        <div class="message-container">
                            <p v-if="showAlert" class="red-alert">Please type your message below</p>
                            <label for="message">Your Message:</label>
                            <textarea :disabled="isEmptyMessage" placeholder="Start typing here..." maxlength="200" v-model="message.text" cols="30" rows="3" id="message"></textarea>
                        </div>
                        <div class="from-container">
                            <p v-if="showAlert" class="red-alert">Please type your message below</p>
                            <label for="from">From:</label>
                            <input :disabled="isEmptyMessage" placeholder="Your Name" maxlength="200" v-model="message.from" id="from" type="text">
                            <p class="purple-span" :class="remainingCharacters < 0 ? 'red' : ''">Characters Remaining {{remainingCharacters}}</p>
                        </div>
                    </div>
                </div>
                <div v-else-if="!noCard && !paidCard && hasMultipleCards" class="addresses-container">
                    <p class="addresses-title"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/assitance.svg?v=1718205326" alt="customize" width="20px" height="10px"/> Recipient List</p>
                    <div class="multiple-addresses-container">
                        <div class="address-container" v-for="(address,i) in addresses" :key="address.id" :class="[i % 2 == 0 ? 'odd' : 'even']">
                            <div class="title-container">
                                <p>Gift Quantity</p>
                                <p>Card</p>
                            </div>
                            <div class="selectors-container">
                                <select class="address-qty-selector" @change="checkSelectedQty" v-model="addresses[i].qty">
                                    <option v-for="qty in maxQtyPerAddress(address)" :key="qty" :value="qty">{{qty}}</option>
                                </select>
                                <button @click="selectAddress(i)" class="happybox-button border" :class="address.card && (address.isEmpty || address.message.length > 0) ? 'green' : 'white'">{{address.card && (address.isEmpty || address.message.length > 0) ? 'Selected!' : 'Select your card'}}</button>
                            </div>
                            <img v-if="addresses.length > 1" @click="popAddress(i)" class="remove lazyload" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_1.svg?v=1732737242" />
                        </div>
                    </div>
                    <button @click="addNewAddress()" class="add-address" :class="canAddMoreAddresses ? '' : 'disabled'">+ Add new address</button>
                </div>
                <div id="write-container" class="write-container" v-else-if="!noCard && paidCard">
                    <div class="pick-card-container">
                        <div class="paid-card-header">
                            <div class="selection-container">
                                <p class="title">Add a handwritten card for $6</p>
                                <div class="blank-card-container">
                                    <input v-model="selectedPaidCard" id="blankCard" type="checkbox">
                                    <label for="blankCard">I want a card</label>
                                </div>
                            </div>
                            <p class="subtitle">
                                Include a card with each gift. Our team will handwrite your message for you and ship along with the item you choose, directly to your recipient
                            </p>
                        </div>
                        <p v-if="showCardAlert" class="red-alert">Please select a card</p>
                        <div v-if="selectedPaidCard && sortedCards.length > 0" class="cards-container">
                            <div class="card-container" @click="selectCard(card)" :class="selectedCard.id == card.id ? 'selected' : ''" v-for="card in sortedCards" :key="card.id">
                                <img v-if="selectedCard.id == card.id " class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                                <img class="main-image" :src="card | getProductImage"/>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedPaidCard" class="write-header">
                        <p class="title">Write Your Note</p>
                    </div>
                    <div v-if="selectedPaidCard" class="form-container">
                        <p class="purple-span">Type in your message below. A real human will hand write your message and include it in your gift.</p>
                        <div class="message-container">
                            <p v-if="showAlert" class="red-alert">Please type your message below</p>
                            <label for="message">Your Message:</label>
                            <textarea :disabled="!selectedPaidCard" placeholder="Start typing here..." maxlength="200" v-model="message.text" cols="30" rows="3" id="message"></textarea>
                        </div>
                        <div class="from-container">
                            <p v-if="showAlert" class="red-alert">Please type your message below</p>
                            <label for="from">From:</label>
                            <input :disabled="!selectedPaidCard" placeholder="Your Name" maxlength="200" v-model="message.from" id="from" type="text">
                            <p class="purple-span" :class="remainingCharacters < 0 ? 'red' : ''">Characters Remaining {{remainingCharacters}}</p>
                        </div>
                    </div>
                </div>
                <div v-if="isPreorder" class="notification-date-container m-t-2rem">
                    <p class="title">Requested Shipping Date</p>
                    <p class="subtitle m-b-2rem">Your order will be shipped within this date range via UPS Ground shipping (approx. 3–7 days in transit)</p>
                    <date-input-with-icon 
                        v-model="notificationDate" 
                        placeholder="Select Shipping Date Range" 
                        :custom-min-date="minDate" 
                    />
                </div>
                <div class="end-buttons-container">
                    <button @click="addToCart(false)" class="hb-btn primary w-100 flex flex-align-center flex-justify-center lh-1 gap-05vw"><img v-if="isPreorder" src="https://cdn.shopify.com/s/files/1/1363/8433/files/preorder_blue.svg?v=1756235338" height="12px" width="12px" class="h-auto" alt="add to cart" />{{addBtnTxt}}</button>
                    <p class="preorder-alert" v-if="isPreorder">Can be scheduled to ship as early as {{minDateFormatted}}</p>
                    <div v-if="!isMobile" class="ad">
                        <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/build_a_custom_gift_box_2.png?v=1724873739"/>
                        <div class="content-container">
                            <p class="title">Build a Custom Gift Box</p>
                            <p class="subtitle">Shop hundreds of gifts to build 100% personalized gift box.</p>
                            <a href="/products/build-a-box">Start Building ></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isMobile" class="product-legend">
            <p class="title">Ship exactly how you need. In checkout, you'll be able to:</p>
            <p class="subcopy">
                <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/ship_7cab1626-214e-4ea1-9ee3-da0e85c3e33c.svg?v=1724856350"/>
                <span>
                    Bulk ship to one location, ship to many individual addresses, or a mix of both!
                </span>
            </p>
            <p class="subcopy postcard">
                <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/address_fd703cb6-c0b9-46dc-9547-e254a460054a.svg?v=1724856349"/>
                <span>
                    Ship with just an email address. (no physical address needed)
                </span>
            </p>
            <p class="subcopy box-wing">
                <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/shipping_speed.svg?v=1724856349"/>
                <span>Select your shipping speed: rush or standard, international or domestic.</span>
            </p>
        </div>
        <div v-if="isMobile" class="ad">
            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/build_a_custom_gift_box_2.png?v=1724873739"/>
            <div class="content-container">
                <p class="title">Build a Custom Gift Box</p>
                <p class="subtitle">Shop hundreds of gifts to build 100% personalized gift box.</p>
                <a href="/products/build-a-box">Start Building ></a>
            </div>
        </div>
        <div v-if="!noCard && recoProducts.length > 0" class="more-gifts">
            <p class="main-title">Best Sellers</p>
            <div v-if="!isMobile" class="products-container">
                <div class="product-container" v-for="product in recoProducts" @click="selectNewProduct(product)" :key="product.id">
                    <img :src="product | getProductImage">
                    <div class="curated-footer">
                        <div class="curated-desc">
                            <p class="title">{{product.title}}</p>
                            <p class="price">{{product | moneyFormat}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <VueSlickCarousel v-else-if="recoProducts.length > 0" :infinite="true" :dots="true" :arrows="false" :slidesToShow="2" :slidesToScroll="1">
                <div class="product-container" v-for="product in recoProducts" @click="selectNewProduct(product)" :key="product.id">
                    <img :src="product | getProductImage">
                    <button class="happybox-button white border" @click="selectProduct(product)">View Box</button>
                    <div class="curated-footer">
                        <div class="curated-desc">
                            <p class="title">{{product.title}}</p>
                            <p class="price">{{product | moneyFormat}}</p>
                        </div>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div @click="closeAddressModal" v-if="selectedAddress !== null && showCardModal !== false" class="modal-wrapper">
            <div v-on:click.stop class="modal-container">
                <img @click="closeAddressModal" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
                <div class="write-container">
                    <div class="pick-card-container">
                        <div class="pick-card-header">
                            <p class="title">Pick Your Card</p>
                            <div class="arrows-container">
                                <img @click="$refs.cards.prev();" class="l-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="left arrow"/>
                                <img @click="$refs.cards.next();" class="r-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="right arrow"/>
                            </div>
                        </div>
                        <p v-if="showCardAlert" class="red-alert">Please select a card</p>
                        <div v-if="cardProducts.length > 0" class="cards-container">
                            <Flicking ref="cards" class="flicking-goc-collection" :plugins="plugins2" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: 5 }">
                                <div class="card-container" @click="selectAddressCard(card)" :class="addresses[selectedAddress].card == card.title ? 'selected' : ''" v-for="card in sortedCards" :key="card.id">
                                    <img v-if="addresses[selectedAddress].card == card.title " class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                                    <img class="main-image" :src="card | getProductImage"/>
                                </div>
                            </Flicking>
                        </div>
                        <ul v-else-if="cardProducts.length == 0" class="cards-container no-scrollbar">
                            <li class="card-container" v-for="n in 12" :key="n">
                                <CardSkeleton/>
                            </li>
                        </ul>
                    </div>
                    <div class="write-header">
                        <p class="title">Write Your Note</p>
                        <div class="blank-card-container">
                            <input v-model="addresses[selectedAddress].isEmpty" id="blankCard" type="checkbox">
                            <label for="blankCard">Leave the card blank</label>
                        </div>
                    </div>
                    <div v-if="!addresses[selectedAddress].isEmpty" class="form-container">
                        <p class="purple-span">Type in your message below. A real human will hand write your message and include it in your gift.</p>
                        <div class="message-container">
                            <p v-if="showAlert" class="red-alert">Please type your message below</p>
                            <label for="message">Your Message:</label>
                            <textarea placeholder="Start typing here..." maxlength="200" v-model="addresses[selectedAddress].message" cols="30" rows="3" id="message"></textarea>
                        </div>
                        <div class="from-container">
                            <p v-if="showAlert" class="red-alert">Please type your message below</p>
                            <label for="from">From:</label>
                            <input placeholder="Your Name" maxlength="200" v-model="addresses[selectedAddress].from" id="from" type="text">
                            <p class="purple-span" :class="remainingAddressCharacters < 0 ? 'red' : ''">Characters Remaining {{remainingAddressCharacters}}</p>
                        </div>
                    </div>
                </div>
                <div class="actions-container">
                    <button @click="confirmCardAddress()" class="happybox-button green border">Confirm</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from "axios";
import VueSlickCarousel from 'vue-slick-carousel'
import CardSkeleton from './Skeletons/CardSkeleton.vue';
import { AutoPlay, Arrow } from "@egjs/flicking-plugins";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import DateInputWithIcon from '../../../multiship/Multiship/components/Snippets/DateInputWithIcon.vue';

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
require('dotenv').config();


export default {
    components: {
        VueSlickCarousel,
        CardSkeleton,
        DateInputWithIcon
    },
    data(){
        return{
            selectedImage: null,
            didModify: false,
            selectedCard: {},
            isEmptyMessage: false,
            selectedPaidCard: false,
            boxQty: 1,
            selectedBoxQty: 1,
            isNoCard: false,
            message: {
            text: "",
            from: ""
            },
            showAlert: false,
            showCardAlert: false,
            plugins1: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: true })],
            plugins2: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: true })],
            hasMultipleCards: false,
            //multiplecards
            addressesQty: 1,
            addresses: [{id:1,qty:1,from:"",message:"",card:null, isEmpty: false}],
            selectedAddress: null,
            showCardModal: false,
            descExpanded: false,
            notificationDate: null,
            minDate: window.PREORDER_MIN_DATE
        };
    },
    watch:{
        boxQty:{
            handler(val,oldvalue){
                if(oldvalue > val && this.addressesQty > val){
                    this.adjustAddresses();
                }
            },
        }
    },
    props:{
        curatedBox: Object
    },
    computed:{
        ...mapGetters([
            'collectionProducts',
            'cardProducts',
            'mainCollection',
            'categoriesList'
        ]),
        minDateFormatted(){
            const parts = this.minDate.split("-");
            if (parts.length !== 3) return this.minDate;
            const [y, m, d] = parts.map(Number);
            if (!y || !m || !d) return this.minDate;

            // Construct local date (no TZ shift)
            const localDate = new Date(y, m - 1, d);
            return new Intl.DateTimeFormat("en-US").format(localDate);
        },
        currentImage(){
            if (this.selectedImage){
                return this.selectedImage;
            }
            else if (this.curatedBox){
                return this.curatedBox.images[0].src;
            }
        },
        curatedBoxTitle(){
            return this.curatedBox.title;
        },
        curatedBoxImages(){
            var images = []
            if(Object.keys(this.curatedBox).length != 0){
                images = this.curatedBox.images;
                var variantImages = this.curatedBox.variants.filter(x => x.featured_image).map(x => x.featured_image.src.replace("https:",""));
                images = images.filter(function(image) {
                    return !variantImages.includes(image);
                });
            }
            return images;
        },
        currentPrice(){
            if(this.curatedBox)
                if(this.curatedBox.variants){
                    let variantPrice = this.curatedBox.variants.find(x => x.price != 0);
                    if(variantPrice)
                        return `$${(variantPrice.price * this.boxQty).toFixed(2)}`;
                }

            return 0
        },
        remainingCharacters(){
            var remainingCharacters = 200;
            remainingCharacters = remainingCharacters - (this.message.text.length + this.message.from.length)
            return remainingCharacters;
        },
        remainingAddressCharacters(){
            var remainingCharacters = 200;
            remainingCharacters = remainingCharacters - (this.addresses[this.selectedAddress].message.length + this.addresses[this.selectedAddress].from.length)
            return remainingCharacters;
        },
        description(){
            if(this.curatedBox)
            return this.curatedBox.body_html;
            
            return '';
        },
        boxesOnCart(){
            let boxes = 0;
            if(this.cart && this.curatedBox && this.cart.items){
                var cartItem = this.cart.items.filter(x => x.product_id == this.curatedBox.id);
                if(cartItem){
                    boxes = cartItem.reduce((prev, next) => prev + next.quantity, 0);;
                }
            }

            return boxes
        },
        maxBoxes(){
            let boxQty = 0 - this.boxesOnCart;
            if(this.curatedBox){
                if(this.curatedBox.variants){
                    if(this.priceVariantId.inventory_policy == "continue"){
                        boxQty = 99999;
                    }
                    else
                        boxQty += this.priceVariantId.inventory_quantity;
                }  
            }

            return boxQty
        },
        canAddMore(){
            return this.boxQty < this.maxBoxes;
        },
        isMobile() {
            return window.innerWidth < 768;
        },
        noCard(){
            if(this.curatedBox){
            if(this.curatedBox.tags)
                return this.curatedBox.tags.includes("no_card")
            }

            return false;
        },
        paidCard(){
            if(this.curatedBox){
            if(this.curatedBox.tags)
                return this.curatedBox.tags.includes("paid_card");
            }

            return false;
        },
        recoProducts(){
            return this.collectionProducts.filter(x => x.id != this.curatedBox.id).slice(0,5);
        },
        currentCategory(){
        if(this.mainCollection && this.mainCollection.handle && this.categoriesList.length > 0){
          let category = this.categoriesList.find(x => x.handle == this.mainCollection.handle);

          return category.name;
        }

        return ""
      },
      priceVariantId(){
        if(this.curatedBox)
            if(this.curatedBox.variants){
                let variantPrice = this.curatedBox.variants.find(x => x.price != 0);
                return variantPrice;
            }

        return null
      },
      minQty(){
        if(this.curatedBox){
            let tags = [];
            if(Array.isArray(this.curatedBox.tags)){
                tags = this.curatedBox.tags
            }
            else {
                tags = this.curatedBox.tags.split(", ")
            }
            let minqtyTag = tags.find(x => x.includes("QTYMIN_"))
            if(minqtyTag){
                return parseInt(minqtyTag.split("_")[1]);
            }
        }
        return 1
      },
      isPreorder(){
        let tags = [];
        if(Array.isArray(this.curatedBox.tags)){
            tags = this.curatedBox.tags
        }
        else {
            tags = this.curatedBox.tags.split(", ")
        }
        return tags.find(x => x.includes("preorder")) ? true : false;
      },
      isDropship(){
        let tags = [];
        if(Array.isArray(this.curatedBox.tags)){
            tags = this.curatedBox.tags
        }
        else {
            tags = this.curatedBox.tags.split(", ")
        }
        return tags.find(x => x.includes("Dropship_")) ? true : false;
      },
      addBtnTxt(){
        if(this.isPreorder){
            return "Preorder";
        }
        else {
            return "Add to cart";
        }
      },
      sortedCards(){
        if(this.curatedBox && this.cardProducts){
            let tags = [];
            if(Array.isArray(this.curatedBox.tags)){
                tags = this.curatedBox.tags
            }
            else {
                tags = this.curatedBox.tags.split(", ")
            }
            //get occasion tag
            let occasion = tags.find(x => x.toLowerCase().includes("filter_occasion"))
            if(occasion){
                occasion = occasion.split("_");
                occasion = occasion[occasion.length - 1];
            }
            else 
                return this.cardProducts;

            return this.cardProducts.sort((a,b) => {
                let bI = b.tags.includes(occasion) ? 1 : 0;
                let aI = a.tags.includes(occasion) ? 1 : 0;
                return bI - aI;
            });
        }

        return [];
      },
      //multiplecards
        addressesQuantities(){
            return this.addresses.reduce((partialSum,a) => partialSum + a.qty,0);
        },
        canAddMoreAddresses(){
            return this.maxBoxes > this.addresses.length;
        },
    },
    methods:{
        selectImage(image){
            this.selectedImage = image;
        },
        incrementBoxQty(increment){
            if(increment){
                this.changeBoxQty(this.boxQty + 1);
            }
            else {
                if(this.boxQty > this.minQty){
                    this.boxQty--;
                    this.selectedBoxQty--;
                }
            }
        },
        changeBoxQty(qty){
            //Validate if cart products can support box qty if not show alert
            this.selectedBoxQty = qty ? qty : this.selectedBoxQty
            if(this.selectedBoxQty <= this.maxBoxes)
            this.boxQty = this.selectedBoxQty;
            else
            this.selectedBoxQty = this.boxQty;
        },
        addToCart(redirect = false) {
            try {
                // Validate form data
                if (!this.validateFormData()) {
                    return;
                }

                // Prepare cart items
                const productsToAdd = this.prepareCartItems();
                
                // Add to cart
                this.ajaxAddCart(productsToAdd, redirect);
            } catch (error) {
                console.error('Error adding to cart:', error);
                alert('An error occurred while adding to cart. Please try again.');
            }
        },

        validateFormData() {
            // Validate multiple cards if applicable
            if (this.hasMultipleCards && !this.validateMultipleCards()) {
                return false;
            }

            // Validate card selection
            if (!this.noCard && !this.isNoCard && !this.validateCardSelection()) {
                return false;
            }

            // Validate message if required
            if (!this.noCard && !this.isNoCard && !this.validateMessage()) {
                return false;
            }

            // Validate character count
            if (this.remainingCharacters < 0) {
                return false;
            }

            if(this.isPreorder && (!this.notificationDate || this.notificationDate === '')){
                return false;
            }

            return true;
        },

        validateMultipleCards() {
            const allCardsValid = this.addresses.every((address) => 
                address.card && (address.isEmpty || address.message.length > 0)
            );

            if (!allCardsValid) {
                this.showCardValidationAlert();
                return false;
            }

            return true;
        },

        validateCardSelection() {
            const hasValidCard = this.selectedCard.id || this.isNoCard || this.paidCard || this.hasMultipleCards;
            const hasValidPaidCard = !this.selectedPaidCard || this.selectedCard.id;

            if (!hasValidCard || !hasValidPaidCard) {
                this.showCardAlert = true;
                document.getElementById("write-container").scrollIntoView();
                return false;
            }

            this.showCardAlert = false;
            return true;
        },

        validateMessage() {
            if (!this.isEmptyMessage && this.message.text.length < 1 && !this.isNoCard && this.selectedPaidCard) {
                this.showAlert = true;
                document.getElementById("write-container").scrollIntoView();
                return false;
            }

            this.showAlert = false;
            return true;
        },

        prepareCartItems() {
            const uniqueKey = Date.now();
            const properties = this.buildProductProperties(uniqueKey);
            const productsToAdd = [];

            // Handle paid card separately
            if (this.paidCard && this.selectedPaidCard) {
                this.addPaidCardToProducts(productsToAdd, uniqueKey);
            }

            // Handle multiple cards
            if (this.hasMultipleCards) {
                return this.buildMultipleCardProducts(properties);
            }

            // Handle single product
            productsToAdd.push({
                id: this.priceVariantId.id,
                quantity: this.boxQty,
                properties: properties,
            });

            return productsToAdd;
        },

        buildProductProperties(uniqueKey) {
            const properties = {
                _uniqueKey: uniqueKey
            };

            // Add message properties for non-paid cards
            if (!this.paidCard && !this.isNoCard && !this.noCard) {
                this.addMessageProperties(properties);
                this.addCardProperties(properties);
            }

            // Add dropship properties
            this.addDropshipProperties(properties);

            // Add preorder properties
            this.addPreorderProperties(properties);

            // Add minimum quantity
            if (this.minQty > 1) {
                properties.qtyMin = this.minQty;
            }

            if(this.notificationDate){
                properties.scheduledDate = this.notificationDate;
            }

            return properties;
        },

        addMessageProperties(properties) {
            if (!this.isEmptyMessage) {
                properties.Message = this.message.text;
                properties.From = this.message.from;
            } else {
                properties.Message = "";
                properties.From = "";
            }
        },

        addCardProperties(properties) {
            const cardTitle = this.selectedCard.id ? this.selectedCard.title : this.cardProducts[0].title;
            properties.Card = cardTitle;
            properties.LeaveCardBlank = this.isEmptyMessage;
        },

        addDropshipProperties(properties) {
            const tags = this.getProductTags();
            const dropshipTag = tags.find(x => x.includes("Dropship_"));
            
            if (dropshipTag) {
                const dropshipIdTag = tags.find(x => x.includes("DropshipId_"));
                properties._Dropship = dropshipTag.split("_")[1];
                properties._DropshipId = dropshipIdTag.split("_")[1];
            }
        },

        addPreorderProperties(properties) {
            if (this.isPreorder) {
                properties._preorder = true;
            }
        },
        addPaidCardToProducts(productsToAdd, uniqueKey) {
            const cardId = this.selectedCard.id ? this.selectedCard.variants[0].id : this.cardProducts[0].variants[0].id;
            productsToAdd.push({
                id: cardId,
                quantity: this.boxQty,
                properties: {
                    _hide: true,
                    _uniqueKey: uniqueKey,
                },
            });
        },

        buildMultipleCardProducts(baseProperties) {
            return this.addresses.map((address) => ({
                id: this.priceVariantId.id,
                quantity: address.qty,
                properties: {
                    ...baseProperties,
                    From: address.from,
                    Card: address.card,
                    Message: address.message
                },
            }));
        },

        getProductTags() {
            if (Array.isArray(this.curatedBox.tags)) {
                return this.curatedBox.tags;
            }
            return this.curatedBox.tags.split(", ");
        },

        showCardValidationAlert() {
            Swal.fire({
                iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
                html: `<p class="title">Please fill all the cards information</p>`,
                confirmButtonText: 'Go Back',
                customClass: {
                    container: "swal-custom-container",
                    popup: "swal-custom-popup-3",
                    title: "swal-title",
                    confirmButton: "happybox-button green border",
                },
                buttonsStyling: false,
            });
        },

        showErrorAlert(message) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
                confirmButtonText: 'OK'
            });
        },
        async ajaxAddCart(itemsToAdd, redirect) {
            try {
                const res = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ items: itemsToAdd })
                });

                if (!res.ok) {
                    throw new Error(`Request failed with status ${res.status}`);
                }

                const response = await res.json(); // Shopify returns JSON

                // Set cartDate if not present
                localStorage.setItem("cartDate", Date.now());

                if (redirect) {
                    localStorage.setItem("openCart", true);
                    window.location.href = "/";
                } else {
                    if (typeof window.openCartDrawer === "function") {
                        window.openCartDrawer();
                    }
                }
            } catch (err) {
                console.error("Error adding to cart:", err);
            }
        },
        goBack(){
            if(document.referrer.includes("/pages/holiday-gifts") && !history.state?.referrer){
                history.back();
            }
            else{
                history.pushState(null,"",`/pages/ready-to-ship`);
                this.$store.commit("setSelectedProduct",null);
            }
        },
        selectNewProduct(product){
            this.selectedCard = {};
            this.$store.commit("setSelectedProduct",product);
            window.scrollTo({ top: 0, behavior: 'auto' });
        },
        selectCard(card){
            this.selectedCard = card;
        },
        //addresses
        popAddress(i){
            if(this.addresses.length > 1){
                this.addresses.splice(i,1);
                this.addressesQty--;
            }
        },
        recalculateAddressesQty(){
            var currentQty = this.addressesQuantities;
            if(currentQty > this.boxQty){
                var extraQty = currentQty - this.boxQty;
                for(extraQty; extraQty > 0; extraQty--){
                    let addressesQty = this.addresses.map(x => x.qty);
                    const max = Math.max(...addressesQty);
                    let address = this.addresses.find(x => x.qty == max);
                    address.qty = address.qty - 1;
                }
            }
        },
        maxQtyPerAddress(address){
            let addressesQty = this.addressesQuantities;
            addressesQty = addressesQty - address.qty;
            let maxCurrentQty = this.maxBoxes != Infinity ? this.maxBoxes : this.boxQty;
            const min = 1,
            max = Math.max(...[maxCurrentQty - addressesQty,address.qty]),
            interval = 1;
            const length = (max - min) / interval + 1;
            const arr = Array.from({ length }, (_, i) => min + i * interval);
            return arr;
        },
        addNewAddress(){
            if(this.addresses.length < this.maxBoxes && this.maxBoxes > this.boxQty){
                if(this.addresses.length + 1 > this.boxQty){
                    this.boxQty += 1;
                    this.selectedBoxQty += 1;
                }
                this.addresses.push({id:new Date().getTime(),qty:1,from:"",message:"",card:null, isEmpty: false});
                this.addressesQty++;
                this.recalculateAddressesQty();
            }
        },
        recalculateAddressesQty(){
            var currentQty = this.addressesQuantities;
            if(currentQty > this.boxQty){
                var extraQty = currentQty - this.boxQty;
                for(extraQty; extraQty > 0; extraQty--){
                let addressesQty = this.addresses.map(x => x.qty);
                const max = Math.max(...addressesQty);
                let address = this.addresses.find(x => x.qty == max);
                address.qty = address.qty - 1;
                }
            }
        },
        checkSelectedQty(){
            if(this.addressesQuantities > this.boxQty){
                this.boxQty = this.addressesQuantities;
                this.selectedBoxQty = this.addressesQuantities;
            }
        },
        adjustAddresses(){
            var newAddressesqty = this.addressesQty - this.addresses.length;
            if(newAddressesqty > 0){
                for(let i = 1; i <= newAddressesqty; i++){
                    this.addresses.push({id:new Date().getTime() + i,qty:1,from:"",message:"",card:null, isEmpty: false})
                }
            }
            else if (newAddressesqty < 0){
                this.addresses = JSON.parse(JSON.stringify(this.addresses.slice(0,this.addresses.length + newAddressesqty)));
            }
            this.recalculateAddressesQty();
        },
        selectAddress(i){
            this.selectedAddress = i;
            this.showCardModal = true;
        },
        selectAddressCard(card){
            this.$set(this.addresses[this.selectedAddress], 'card', card.title);
        },
        confirmCardAddress(){
            if((!this.addresses[this.selectedAddress].card)){
                this.showCardAlert = true;
                return;
            }
            this.showCardAlert = false;
            if(!this.addresses[this.selectedAddress].isEmpty && this.addresses[this.selectedAddress].message.length < 1){
                this.showAlert = true;
                return;
            }
            this.showAlert = false;
            this.showCardModal = false;
        },
        closeAddressModal(){
            this.showCardModal = false;
        },
        changeMultipleCards(){
            if(this.hasMultipleCards){
                this.addresses = Array(this.boxQty).fill(0).map((x,i) => ({id:i,qty:1,from:"",message:"",card:null, isEmpty: false}));
            }
        }
    },
    mounted() {
        if(this.curatedBox){
            let tags = [];
            if(Array.isArray(this.curatedBox.tags)){
                tags = this.curatedBox.tags
            }
            else {
                tags = this.curatedBox.tags.split(", ")
            }
            let minqtyTag = tags.find(x => x.includes("QTYMIN_"))
            if(minqtyTag){
                this.boxQty = parseInt(minqtyTag.split("_")[1]);
                this.selectedBoxQty = parseInt(minqtyTag.split("_")[1]);
            }
        }
    },
    destroy() {
    }
}
</script>

<style scoped>

.desktop-flex{
        display: flex;
    }

.ad{
    width: 100%;
    position: relative;
    margin-top: 2rem
}

.ad img{
    width: 100%;
}

.ad .content-container{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}

.ad .content-container .title{
    font-size: 1.3vw;
    font-weight: bold;
}

.ad .content-container .subtitle{
    font-size: 1.15vw;
    line-height: 1.2;
}

.ad .content-container a{
    color: #A01ADB;
    font-weight: bold;
    font-size: 1.15vw;
    text-decoration: underline;
    margin-top: 0.5rem;
    cursor: pointer;
}

.desc-title{
    display: none;
}

.branding-legend{
    font-size: 1vw;
    margin-bottom: 1rem;
}

.images-container{
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    gap: 2%;
    align-items: flex-start;
}

.images-container .main-image{
    width: 80%;
}

.extra-images-container{
    display: flex;
    position: relative;
    width: 15%;
}

.extra-image{
    width: 100%;
    margin-bottom: 0.5rem;
    background-color: #f6f6f6;
    cursor: pointer;
}

.extra-image.selected{
    border: 1px solid black;
}

.product-desc{
    font-size: 1vw;
    line-height: 1.5;
    color: #0F0C38;
    border-radius: 8px;
    padding: 4%;
    background-color: #f6f6f6;
}

.addresses-container{
    width: 100%;
    box-shadow: 0 0 2px #0000004d;
    border-radius: 8px;
    background-color: #fff;
  }

  .addresses-container p{
    margin: unset;
    color: #0F0C38;
  }

  .addresses-title{
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
    padding: 2%;
    display: flex;
    align-items: center;
  }

  .addresses-title img{
    height: 1.3vw;
    width: auto;
    margin-right: .5rem;
  }

  .quantity-title{
    font-weight: bold;
    padding-bottom: 1%;
  }

  .address-qty-container{
    display: flex;
    flex: 3;
    align-items: center;
    gap: 5px;
    flex-direction: column;
  }

  .addresses-subtitle{
    font-weight: 700;
    font-size: 1.15vw;
    line-height: 1.4;
  }

  .multiple-addresses-container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .title-container{
    display: flex;
    width: 100%;
    align-items: center;
    gap: 1%;
  }

  .title-container p{
    font-weight: bold;
    font-size: 1.15vw;
    line-height: 1.6;
    flex: 1;
  }

  .addresses-qty-selector{
    width: 15%;
    padding: 0% 4% 0% 1%;
    border-radius: 6px !important;
  }

  .address-container{
    width: 100%;
    padding: 2% 5%;
    border-radius: 8px;
    position: relative;
  }

  .address-container .remove{
    position: absolute;
    right: -1.5%;
    height: 25%;
    top: -12%;
    cursor: pointer;
    background-color: white;
    border: 1.5px solid #0f0c38;
    padding: 0.5%;
    border-radius: 50%;
  }

  .address-container.odd{
    border-bottom: 1px solid lightgray;
    border-top: 1px solid lightgray;
    background-color: #f7f7f7;
  }

  .address-container.odd:last-child{
    border-bottom: unset
  }

  .selectors-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1%;
  }

  .selectors-container > *{
    flex: 1;
    width: 10%;
    padding: 1%;
  }

  .selectors-container > p{
    font-size: 1vw;
  }

  .addresses-qty-selector,.address-qty-selector,.address-selector,.selectors-container > .mx-datepicker,.selectors-container > input,.selectors-container > select{
    border: 1px solid #d8d8d8;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    border-radius: 10px;
    height: unset !important;
    font-size: 1vw;
    background-color: white;
    padding: 1%;
  }

  .selectors-container .mx-datepicker{
    border: unset;
    background-color: unset;
    box-shadow: unset;
  }

  .address-container button{
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
  }
  

  .add-address{
    color: #a01adb;
    border: 1.5px solid #a01adb;
    display: flex;
    gap: 5px;
    align-items: flex-end;
    padding: 1% 2%;
    border-radius: 100px;
    font-weight: bold;
    line-height: 1;
    width: 40%;
    margin-left: 3%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    justify-content: center;
  }

  .add-address.disabled{
    opacity: 0.6;
  }

  .modal-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 43;
  }

  .modal-container{
    background-color: white;
    width: 60%;
    height: auto;
    overflow-y: auto;
    padding: 3% 3% 0 3%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 16px;
    justify-content: flex-start;
    box-shadow: 0 0 3px #00000050;
    position: relative;
    max-height: 90%;
  }

  .modal-container .x{
    position: absolute;
    top: 1%;
    right: 2%;
    width: 5%;
    cursor: pointer;
  }

  .modal-wrapper .actions-container{
    width: 100%;
    display: flex;
    margin-top: 1rem;
    justify-content: flex-end;
    position: sticky;
    bottom: 0;
    background-color: white;
    padding-bottom: 5%;
  }

  .product-page{
    padding-top: 10%;
  }

@media screen and (max-width:767px){
    .desktop-flex{
      display: none !important;
    }
    .ad .content-container .title{
        font-size: 3.5vw;
    }

    .ad .content-container a,.ad .content-container .subtitle{
        font-size: 3vw;
    }

    .desc-title{
        width: 100%;
        display: block;
        font-size: 5vw;
        line-height: 1;
        font-weight: bold;
        border-bottom: 1px solid lightgray;
        margin-bottom: 0.5rem;
        padding-bottom: 0.5rem;
    }

    .branding-legend{
        font-size: 3vw;
    }

    .product-desc{
        font-size: 3vw;
        height: 100px;
        overflow: hidden;
        transition: all 1s;
    }

    .product-desc.expanded{
        height: auto;
    }

    .addresses-container{
        margin-top: 1rem;
    }

    .purple-expand{
        width: 100%;
        color: #a01adb;
        text-decoration: underline;
        font-weight: 700;
        font-size: 3vw;
        padding: 2% 5%;
        text-align: right;
    }

    .addresses-title,.directions-title,.file-uploader{
      font-size: 4vw;
    }

    .address-qty-selector,.selectors-container>select{
        font-size: 3.5vw;
    }

    .addresses-title img{
      height: 3.5vw;
    }

    .title-container p,.item-title span{
      font-size: 3vw;
    }

    .modal-container{
        width: 90%;
    }
}
</style>